import {
  Component,
  OnInit,
} from '@angular/core';
import { NavigationExtras } from '@angular/router';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-admin-category-list',
  templateUrl: './admin-category-list.component.html',
  styleUrls: ['./admin-category-list.component.scss'],
})
export class AdminCategoryListComponent implements OnInit {

  categorylist: any = [];
  all_products: any = [];
  title;
  category:any={};
  active: any = -1;
  editcategory;
  check_box = false;
  loadMoreData = true;
  limit_start = 0;
 //  itemExpandHeight;
 //  category;
 //  subcategory = [];
 //  active;
 //  pageloaded: any;
 //  len:any =0;
 //  show_location_error = false;

 //  shownGroup;
 // shownGroup1;
  // @ViewChild('scrollMe') private myScrollContainer: ElementRef;

// private modalService: NgbModal,public storage: Storage,
  constructor(public navCtrl: NavController,public alertCtrl: AlertController,public loadingCtrl: LoadingController,public DBservice: DataService,public modalCtrl: ModalController,private router:Router) { }

  ngOnInit() {
    this.DBservice.get_all_products().subscribe((data: any) => {
      this.all_products = data.message;
      // this.storage.set('selectmenu', data.message)
    }, error => { console.log(JSON.stringify(error.json())); 
    });
    this.get_categorylist(0);
  }

  onCategoryChange(){
    
  }

  // drop(event: CdkDragDrop<string[]>) {
  //   // if (event.previousContainer === event.container) {
  //   //   moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  //   // } else {
  //   //   transferArrayItem(event.previousContainer.data,
  //   //     event.container.data,
  //   //     event.previousIndex,
  //   //     event.currentIndex);
  //   // }
  // }

  // ionViewWillEnter() {
  //   this.get_categorylist(0);
  // }

  cat_count(id) {
    let count:any = [];
    this.all_products.map(res=>{
          res.category_mapping.map(value =>{
            if(value.category == id)
              // all_data = [...all_data,...res]
               count.push(res)
          })
        })
    return count.length
  }


  get_categorylist(limit_start) {

        var data = {
          // name: localStorage.restaurantId,
          domain: localStorage['active_domain']
        }
        // this.DBservice.get_categories(data)
        this.DBservice.get_all_category(data,10,limit_start).subscribe(data => {
            
            if(data.data && data.data.length > 0){
              limit_start == 0 ? this.categorylist = data.data : null
              data.data.map(value => {
               limit_start != 0 ? this.categorylist.push(value): null
              })
              console.log(this.categorylist)
           }
           else
             this.loadMoreData = false
            // this.categorylist = data.data;
          }, error => {
            console.log(JSON.stringify(error.json()));
          });
  }


  async openModal(pageName, css: string[]) {
    const modal = await this.modalCtrl.create({
      component: pageName,
      cssClass: css // Global.scss
    });
    await modal.present();
  }


  getmenuitems(c, index,content) {
      this.active = index
      this.editcategory = c;
      // this.open(content,'Edit')
      // this.menulist = c.products;
  }


  open_category(title){
    //  this.navCtrl.navigateForward(['add-category'], {});
    this.navCtrl.navigateForward(['/my-profile/order/'], {});
  }



  edit_category(value,index){
    
      if(this.DBservice.ismobile){
        let params: NavigationExtras = {
          queryParams: {'id': value.name}
        }
        this.navCtrl.navigateForward(['add-category'], params)
      }else{
        this.router.navigateByUrl('/my-profile/view-category/'+value.name);
      } 
    //  this.navCtrl.navigateForward(['add-category'], params);
    // this.navCtrl.navigateForward(['/my-profile/view-category/'], params);
    //  /my-profile/order/'+item.name
  }


  close(form){
    console.log(form)
    this.category.is_active =true;
    this.category.domain =localStorage['active_domain'];
    if(form.valid){
      if(this.title == 'Edit'){
        var data={
          name:this.category.name,
          category_name:this.category.category_name,
          description:this.category.description,
          is_active:this.category.is_active,
          product_category_name : this.category.category_name,
          domain:localStorage['active_domain']

        }
        this.insert_category(data,'Category Updated Successfully','Edit')
      }
      else
        this.insert_category(this.category,'Category Added Successfully','Add')
     }
  }
  

  insert_category(category,text,type){
    this.DBservice.add_menu_category(category,type)
      .then(res => {
        console.log(res)
        // this.modalService.dismissAll()
        this.get_categorylist(0);
      })
  }

  onScroll(event: any) {
   if(this.loadMoreData){    
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 1) {
      this.limit_start = this.limit_start + 10;
      this.get_categorylist(this.limit_start);
    }
   } 
  }



}

